export const environment = {
  production: false,
  apiKey: 'AIzaSyBusDK5LpyN9nQ14DK3VQTfvgeVKcJQKcs',
  fbDbUrl: 'https://jspractice-app.firebaseio.com/'
};
